import { useMemo } from 'react';

import { getFilterOptions } from '../helpers/filter';

import { BLANK_FILTER_TEXT } from '../constants/livestock';

function getUniqueFarmOptions(data) {
  const uniqueFarmsMap = new Map();

  data?.forEach(l => {
    const farm = l.farm;
    if (farm) {
      if (!uniqueFarmsMap.has(farm.id)) {
        uniqueFarmsMap.set(farm.id, { text: farm.name, value: farm.id });
      }
    } else {
      uniqueFarmsMap.set('blank', { text: BLANK_FILTER_TEXT, value: 'blank' });
    }
  });

  return Array.from(uniqueFarmsMap.values());
}

export const useFilterOptions = ({ animals }) => {
  return useMemo(() => {
    if (!Array.isArray(animals) || animals.length === 0) {
      return {
        breeds: [],
        connectionStatuses: [],
        farms: [],
        locations: [],
        sex: []
      };
    }

    const locationsSet = new Set();

    animals.forEach(animal => {
      const firstGeofence = animal.assigned_geofences?.[0];
      locationsSet.add(firstGeofence || BLANK_FILTER_TEXT);
    });

    const locationOptions = Array.from(locationsSet).map(location => ({
      text: location,
      value: location
    }));

    return {
      breeds: getFilterOptions(animals, 'breed', 'display_name'),
      connectionStatuses: getFilterOptions(animals, 'tag', 'status'),
      farms: getUniqueFarmOptions(animals),
      locations: locationOptions,
      sex: getFilterOptions(animals, 'sex')
    };
  }, [animals]);
};
